var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateThread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2457_73648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2754 17.7343C28.2754 16.8553 27.5628 16.1427 26.6838 16.1427H10.2903C9.41129 16.1427 8.69873 16.8553 8.69873 17.7343C8.69873 18.6133 9.41129 19.3259 10.2903 19.3259H26.6838C27.5628 19.3259 28.2754 18.6133 28.2754 17.7343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2903 22.5091C9.41129 22.5091 8.69873 23.2217 8.69873 24.1007C8.69873 24.9797 9.41129 25.6923 10.2903 25.6923H20.2467C21.1257 25.6923 21.8383 24.9797 21.8383 24.1007C21.8383 23.2217 21.1257 22.5091 20.2467 22.5091H10.2903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0307 37.7885H8.70771C6.95249 37.7885 5.52451 36.3605 5.52451 34.6053V6.59314C5.52451 4.83793 6.95249 3.40994 8.70771 3.40994H28.2755C30.0308 3.40994 31.4587 4.83793 31.4587 6.59314V16.3815C31.4587 17.2605 32.1713 17.9731 33.0503 17.9731C33.9294 17.9731 34.6419 17.2605 34.6419 16.3815V6.59314C34.6419 3.08271 31.786 0.226746 28.2755 0.226746H8.70771C5.19727 0.226746 2.34131 3.08271 2.34131 6.59314V34.6053C2.34131 38.1157 5.19727 40.9717 8.70771 40.9717H14.0307C14.9098 40.9717 15.6223 40.2591 15.6223 39.3801C15.6223 38.501 14.9098 37.7885 14.0307 37.7885Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.461 23.2708C35.5993 21.4091 32.5701 21.409 30.7096 23.2695L21.9715 31.9883C21.7859 32.1735 21.6491 32.4016 21.5728 32.6524L19.6698 38.9173C19.5011 39.4728 19.6481 40.0759 20.0535 40.4914C20.3572 40.8027 20.7697 40.9716 21.1928 40.9716C21.3344 40.9716 21.4773 40.9527 21.6176 40.9137L28.0417 39.1343C28.3061 39.061 28.5471 38.9207 28.7412 38.7269L37.461 30.0235C39.3227 28.1618 39.3227 25.1326 37.461 23.2708ZM26.7887 36.1783L23.5568 37.0736L24.5026 33.9597L30.3986 28.0768L32.6499 30.3281L26.7887 36.1783ZM35.2113 27.7717L34.9029 28.0794L32.652 25.8285L32.9594 25.5218C33.5799 24.9012 34.5896 24.9012 35.2102 25.5218C35.8308 26.1424 35.8308 27.1521 35.2113 27.7717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6838 9.77631H10.2903C9.41129 9.77631 8.69873 10.4889 8.69873 11.3679C8.69873 12.2469 9.41129 12.9595 10.2903 12.9595H26.6838C27.5628 12.9595 28.2754 12.2469 28.2754 11.3679C28.2754 10.4889 27.5628 9.77631 26.6838 9.77631Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2457_73648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.7449,
    height: 40.7449,
    fill: "white",
    transform: "translate(0.226562 0.226746)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateThread);
export default __webpack_public_path__ + "static/media/create-thread.053043058472491d8de32343d6144464.svg";
export { ForwardRef as ReactComponent };